const USGlobals = {
  country: "United States",
};

export { USGlobals };
